import api from '../../store/api/api';

export const allowUber = async ({ campaign_id, sitecanvass_id, doorcanvass_id } = {}) => {
    try {
        const params = {};
        if (campaign_id) params.campaign_id = campaign_id;
        if (sitecanvass_id) params.sitecanvass_id = sitecanvass_id;
        if (doorcanvass_id) params.doorcanvass_id = doorcanvass_id;

        const response = await api.get('/uber/allow/', params);

        return response.data?.allowed ?? false;
    } catch (error) {
        console.error('Error checking if Uber is allowed:', error);
        return false;
    }
};

export default allowUber;